<div class="table-responsive compare-list">
  <table class="table table-bordered table-hover">
    <thead>
    <tr>
      <th>No.</th>
      <th>Profiles</th>
      <th>Status</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td class="font-weight-normal">1</td>
      <td>
        <a class="m-link" href="#">
          <img class="avatar" src="https://scontent.fwaw5-1.fna.fbcdn.net/v/t31.0-8/13987617_10153952346184926_374352024953247352_o.jpg?_nc_cat=110&_nc_sid=85a577&_nc_ohc=W0rT2fY1kDMAX_MsR0S&_nc_ht=scontent.fwaw5-1.fna&oh=4908c16927d44cbdd0a71920e7c9e5a7&oe=5F4DBE44">
          <span class="ml-2">&#64;elajza</span>
          <span class="font-weight-light text-secondary mx-2 mx-3">vs.</span>
          <img class="avatar" src="https://scontent.fwaw5-1.fna.fbcdn.net/v/t1.0-9/36288548_1748877751865294_326713596656484352_o.jpg?_nc_cat=110&_nc_sid=85a577&_nc_ohc=aZXrncxIRMcAX9U5BFp&_nc_ht=scontent.fwaw5-1.fna&oh=aff89cc2860b69e08c202d59de38f758&oe=5F4D1F57">
          <span class="ml-2">&#64;styloly</span>
        </a>
      </td>
      <td>
        <span class="btn-sm label-success mr-2">
          Avaliable
        </span>
      </td>
    </tr>
    <tr>
      <td class="font-weight-normal">1</td>
      <td>
        <a class="m-link" href="#">
          <img class="avatar" src="https://scontent.fwaw5-1.fna.fbcdn.net/v/t31.0-8/13987617_10153952346184926_374352024953247352_o.jpg?_nc_cat=110&_nc_sid=85a577&_nc_ohc=W0rT2fY1kDMAX_MsR0S&_nc_ht=scontent.fwaw5-1.fna&oh=4908c16927d44cbdd0a71920e7c9e5a7&oe=5F4DBE44">
          <span class="ml-2">&#64;elajza</span>
          <span class="font-weight-light text-secondary mx-3">vs.</span>
          <img class="avatar" src="https://scontent.fwaw5-1.fna.fbcdn.net/v/t1.0-9/36288548_1748877751865294_326713596656484352_o.jpg?_nc_cat=110&_nc_sid=85a577&_nc_ohc=aZXrncxIRMcAX9U5BFp&_nc_ht=scontent.fwaw5-1.fna&oh=aff89cc2860b69e08c202d59de38f758&oe=5F4D1F57">
          <span class="ml-2">&#64;styloly</span>
          <span class="font-weight-light text-secondary mx-3">vs.</span>
          <img class="avatar" src="https://instagram.fwaw5-1.fna.fbcdn.net/v/t51.2885-19/s320x320/19955303_143602816218134_1328496091175321600_a.jpg?_nc_ht=instagram.fwaw5-1.fna.fbcdn.net&_nc_ohc=ABqcaF3Xi2wAX_pLf13&oh=daa999bf567359f2b4bf87a3cc92d43a&oe=5F52BF8C">
          <span class="ml-2">&#64;maffashion</span>
        </a>
      </td>
      <td>
                    <span class="btn-sm label-cyan mr-2">
                      Trial
                    </span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
